var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0009 13.3076V15.7692C17.0009 16.0956 16.8712 16.4086 16.6404 16.6394C16.4096 16.8703 16.0966 16.9999 15.7701 16.9999H13.3086",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3086 1H15.7701C16.0966 1 16.4096 1.12967 16.6404 1.36048C16.8712 1.5913 17.0009 1.90435 17.0009 2.23077V4.69231",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.69231V2.23077C1 1.90435 1.12967 1.5913 1.36048 1.36048C1.5913 1.12967 1.90435 1 2.23077 1H4.69231",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69231 16.9999H2.23077C1.90435 16.9999 1.5913 16.8703 1.36048 16.6394C1.12967 16.4086 1 16.0956 1 15.7692V13.3076",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0006 8.38499C9.65344 8.38499 10.2795 8.12565 10.7412 7.66402C11.2028 7.20239 11.4621 6.57629 11.4621 5.92345C11.4621 5.27061 11.2028 4.64451 10.7412 4.18288C10.2795 3.72125 9.65344 3.46191 9.0006 3.46191C8.34776 3.46191 7.72166 3.72125 7.26003 4.18288C6.7984 4.64451 6.53906 5.27061 6.53906 5.92345C6.53906 6.57629 6.7984 7.20239 7.26003 7.66402C7.72166 8.12565 8.34776 8.38499 9.0006 8.38499Z",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6815 13.9235C13.3634 12.9321 12.7387 12.0674 11.8976 11.4539C11.0564 10.8403 10.0421 10.5098 9.00093 10.5098C7.95977 10.5098 6.9455 10.8403 6.1043 11.4539C5.26311 12.0674 4.63843 12.9321 4.32031 13.9235H13.6815Z",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateProfileIcon);
export default __webpack_public_path__ + "static/media/update-profile-icon.3266a02bf7e860b440bfdae073e21c51.svg";
export { ForwardRef as ReactComponent };